import React, { FC, useContext } from 'react'
import { useSelector } from 'react-redux'
import ROUTES from '../../../utils/routes'
import subscriptionImg from './affiliate-subscription-bg.png'
import courseImg from './affiliate-course-bg.jpeg'
import challengeImg from './affiliate-challenge-bg.jpg'
import { userStore } from '../../../utils/UserContext'
import { StyledLinks, LinkCard } from '.'
import { AppState } from '../../../../redux/root-reducer'
import { ChallengeState } from '../../../../redux/challenge/types'
import { SplitContext } from '../../../utils/SplitContext'

const Links: FC = () => {
  const { currentChallenge } = useSelector<AppState, ChallengeState>((state) => state.challenge)
  const { user } = useContext(userStore)
  const { origin } = window.location

  const {
    isReady,
    isEnabled,
    treatments: { showDashboardChallenge }
  } = useContext(SplitContext)

  const showChallengeLink = () => {
    if (!currentChallenge) {
      return false
    }

    const joinBy = new Date(currentChallenge?.joinBy).valueOf()
    const now = new Date().valueOf()

    // only show challenge link if before joinBy date
    if (now < joinBy) {
      return true
    }

    return false
  }

  return (
    <StyledLinks>
      <div className="heading">
        <h2>Your Links</h2>
        <p>Start earning by sharing your link to one of the offers below.</p>
      </div>
      <div className="link-grid">
        <LinkCard
          imageUrl={subscriptionImg}
          title="Social Curator Subscription"
          description="Every time someone uses your link to sign up for a paid subscription, you'll both receive benefits."
          affiliateUrl={`${origin}/a/${user?.id}`}
          detailsUrl={ROUTES.affiliates.buildDetailPage('subscription')}
        />
        <LinkCard
          imageUrl={courseImg}
          title="S.O.S. Selling on Social"
          description={`Earn ${
            user?.isWhale ? '50' : '40'
          }% every time someone uses your link to purchase the course.`}
          affiliateUrl={`${origin}/course/signup?affiliate=${user?.id}`}
          detailsUrl={ROUTES.affiliates.buildDetailPage('course')}
        />
        {showChallengeLink() && isReady && isEnabled(showDashboardChallenge) && (
          <LinkCard
            imageUrl={challengeImg}
            title="5-Day Instagram Challenge for More Followers and Sales"
            description="Every time someone uses your link to sign up for the challenge and upgrades to a paid subscription, you'll both receive benefits."
            affiliateUrl={`${origin}/a/${user?.id}?plan=Challenge`}
            detailsUrl={ROUTES.affiliates.buildDetailPage('challenge')}
          />
        )}
      </div>
    </StyledLinks>
  )
}

export default Links
